import type { IdsModalSettings } from './ids-modal';
import IdsModal from './ids-modal';

/**
 * IDS Notification Service
 */
export default class IdsModalService {
  /* Show a notification Banner */
  static show(settings: IdsModalSettings) {
    const modal = document.createElement('ids-modal') as IdsModal;
    document.body.appendChild(modal);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    modal.show(settings);
  }

  /* Close All notification Banner */
  static hide(id: string) {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (document.querySelector(`#${id}`) as IdsModal)?.hide();
  }

  /* Get button reference for active modals by id */
  static buttons(id: string) {
    return (document.querySelector(`#${id}`) as IdsModal).querySelectorAll('ids-modal-button');
  }
}
